import type { ProjectSubsidyConfig } from 'features/master/api/types';

import type { AlertType } from '../types/alertsConfig';

export type ProjectTab = 'parametros' | 'funcionalidades' | 'funnel';

export interface ProjectListItem {
  id: number;
  name: string;
  masterProjectId: number | null;
  countryCode: string;
  isActive?: boolean;
  subProjects: Array<{ id: number; name: string; masterProjectId: number | null }>;
}

export interface ProjectDetail {
  id: number;
  name: string;
  commune?: string | null;
  countryCode: string;
  masterProjectId: number | null;
  masterProject: {
    id: number;
    name: string;
    financialScoreWeight?: number | null;
    aiScoreWeight?: number | null;
  } | null;
  isActive: boolean;
  phoneNumber: string | null;
  openAIModel?: string | null;
  externalId: string | null;
  minimumPropertyUFPrice: number | null;
  minimumDownPaymentRate: number | null;
  financialScoreWeight: number;
  aiScoreWeight: number | null;
  skipFinancialDataValidationOnIncome: boolean;
  hasProperties: boolean;
  hasFunnel?: boolean;
  hasSaveEmployementDetailsFunctionality: boolean;
  includeSaveBuyerTypeFunction: boolean;
  assignmentAgentEnabled: boolean;
  enableRegistroCivilFeature: boolean;
  enableCamaraComercioFeature: boolean;
  documentAnalyzerEnabled: boolean;
  hasScopeFunctionality: boolean;
  scopes: string[] | null;
  /* Masters only: the project is a financial entity attending its own leads (Lead Management). */
  isFinancialEntity?: boolean;
  /* The agent prompt fields travel with each sub-project: `GET /admin/projects/:id` includes its
     sub-projects with every model attribute, and the mortgage screen reads them per row. */
  subProjects: Array<{
    id: number;
    name: string;
    financialAdvisorAgentPrompt?: string | null;
    mortgageAgentPrompt?: string | null;
    subsidyConfig?: ProjectSubsidyConfig | null;
  }>;
  alertsConfig?: AlertType[] | null;
}

export type UpdateProjectBody = Partial<
  Pick<
    ProjectDetail,
    | 'minimumPropertyUFPrice'
    | 'minimumDownPaymentRate'
    | 'financialScoreWeight'
    | 'aiScoreWeight'
    | 'skipFinancialDataValidationOnIncome'
    | 'hasProperties'
    | 'hasSaveEmployementDetailsFunctionality'
    | 'includeSaveBuyerTypeFunction'
    | 'assignmentAgentEnabled'
    | 'enableRegistroCivilFeature'
    | 'enableCamaraComercioFeature'
    | 'documentAnalyzerEnabled'
    | 'hasScopeFunctionality'
    | 'scopes'
    | 'alertsConfig'
  >
> & {
  prompt?: string;
  commonPrompt?: string;
  changeReason?: string;
  promptLabel?: 'production' | 'latest';
};

export type EditProjectBody = UpdateProjectBody;

export type SubProjectDetail = ProjectDetail & { masterProjectId: number };

export function isSubProjectDetail(p: ProjectDetail): p is SubProjectDetail {
  return p.masterProjectId !== null;
}

export type UpdateSubProjectBody = Partial<
  Pick<
    ProjectDetail,
    | 'name'
    | 'commune'
    | 'externalId'
    | 'skipFinancialDataValidationOnIncome'
    | 'hasProperties'
    | 'hasSaveEmployementDetailsFunctionality'
    | 'includeSaveBuyerTypeFunction'
    | 'enableRegistroCivilFeature'
    | 'enableCamaraComercioFeature'
    | 'documentAnalyzerEnabled'
  >
>;
